<div
    class="entity-item p-3 cursor-pointer position-relative"
    [class.disabled]="!entity().enabled"
    [class.selected]="isSelected()"
    (click)="onClick()"
    [attr.aria-disabled]="!entity().enabled"
    [attr.aria-selected]="isSelected()"
    role="option"
>
    <div class="d-flex align-items-start gap-3">
        <!-- Icon -->
        <div class="entity-icon flex-shrink-0">
            <fa-icon [icon]="entity().icon" size="lg" [class.text-primary]="entity().enabled" [class.text-secondary]="!entity().enabled" aria-hidden="true" />
        </div>

        <!-- Content -->
        <div class="entity-content flex-grow-1 min-width-0">
            <div class="d-flex align-items-center gap-2 mb-1">
                <h6 class="entity-title mb-0">{{ entity().title | artemisTranslate }}</h6>
                <span class="badge bg-secondary text-white px-2 py-1 small">{{ 'global.search.types.' + entity().type | artemisTranslate }}</span>
            </div>
            <p class="entity-description mb-0 text-secondary small">
                {{ entity().description | artemisTranslate }}
            </p>
            @if (!entity().enabled) {
                <p class="entity-coming-soon mb-0 text-muted small fst-italic mt-1">{{ 'global.search.comingSoon' | artemisTranslate }}</p>
            }
        </div>
    </div>

    <!-- Navigation hint for enabled items (positioned absolutely) -->
    @if (entity().enabled && isSelected()) {
        <div class="entity-nav-hint position-absolute text-secondary">
            <kbd class="key-hint-small">#</kbd>
        </div>
    }
</div>
